import script from "./rich-text-box-v2.vue?vue&type=script&setup=true&lang=js"
export * from "./rich-text-box-v2.vue?vue&type=script&setup=true&lang=js"

import "./rich-text-box-v2.vue?vue&type=style&index=0&id=0d5b4988&lang=scss&scoped=true"
import "./rich-text-box-v2.vue?vue&type=style&index=1&id=0d5b4988&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d5b4988"]])

export default __exports__